export default class FailedEncryptionException extends Error {

}
